import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../../_actions/alert.actions'
import { usersService } from '../../../../../_services/users.service'
import { Alert, Button, Col, Modal, Row, Spinner } from 'react-bootstrap'

export default function ResendModal({ user, show, handleClose }) {
  const dispatch = useDispatch(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseModal = () => {
    setError('')
    setLoading(false)
    setTimeout(() => {
      handleClose()
    }, 100);
  }
  
  const handleResend = () => {
    setError('')
    setLoading(true)

    usersService.resendUser(user.userId)
      .then(() => {
        handleClose()
        dispatch(alertActions.success('Email resent.'));
      })
      .catch(() => {
        setError('Could not resend email to user at this time. Please try again.');
      })
      .then(() => {
        setLoading(false)
      })
  }

  return (
    <Modal show={show} onHide={handleCloseModal} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Resend Email</Modal.Title>
      </Modal.Header>

      <Modal.Body className='py-5'>
        { error && <Alert variant='danger'>{ error }</Alert> }
        <Row>
          <Col>
            Are you sure you want to resend the email?
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className='w-100 justify-content-end'>
          <Col xs='4'>
            <Button disabled={loading} onClick={handleResend} block variant='success'>
              { loading ? <Spinner size='sm' animation='border' /> : 'Yes, resend'}
            </Button>
          </Col>
          <Col xs='3'>
            <Button disabled={loading} onClick={handleCloseModal} block variant='secondary'>No, cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
